import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import APP_CONFIG from './config';

import { DomainHolder, DomainProvider } from './lib/domain';
import { basicDomains, networkDomains } from './domains';
// require('typeface-roboto')
import 'typeface-source-sans-pro'

let { dev, target, network, auth } = APP_CONFIG;

const domainHolder = new DomainHolder(
  {
    development_mode: dev,
    target: target,
    network_config: network,
    auth_config: auth,
  }
);
domainHolder.build({ basic: basicDomains, network: networkDomains });


const AppRoot = (props) => {
  return (
    <DomainProvider holder={domainHolder}>
      <App />
    </DomainProvider>
  );
};

ReactDOM.render(<AppRoot />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

